export default __webpack_public_path__ + "static/media/N_wdt_c_cap_0.dd8f9695.mp3";